import { Button, Tooltip, DownloadSimpleIcon } from "@stacklet/ui";

interface Props {
  handleExport: () => void;
  exportInProgress: boolean;
  /** Render as a compact icon-only button (with a tooltip) rather than icon + label. */
  iconOnly?: boolean;
}

export function XGridCustomToolbarExport({
  handleExport,
  exportInProgress,
  iconOnly = false,
}: Props) {
  if (iconOnly) {
    return (
      <Tooltip placement="top" title="Export" asChild>
        <Button
          IconLeft={<DownloadSimpleIcon size={16} />}
          aria-label="Export"
          className="py-xxs"
          isDisabled={exportInProgress}
          onPress={handleExport}
          variant="tertiary"
        />
      </Tooltip>
    );
  }

  return (
    <Button
      IconLeft={<DownloadSimpleIcon size={20} />}
      aria-label="Export"
      isDisabled={exportInProgress}
      onPress={handleExport}
      variant="tertiary"
    >
      Export
    </Button>
  );
}
